import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Form, Input, TextArea } from "semantic-ui-react";
import LoginPassword             from "../../../domain/authentication/LoginPassword";
import FirstName                 from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana             from "../../../domain/fundamentals/name/FirstNameKana";
import LastName                  from "../../../domain/fundamentals/name/LastName";
import LastNameKana              from "../../../domain/fundamentals/name/LastNameKana";
import Staff                     from "../../../domain/staff/Staff";
import StaffMemo                 from "../../../domain/staff/StaffMemo";
import StaffRepository           from "../../../domain/staff/StaffRepository";
import StaffDataSource           from "../../../infrastructure/datasource/staff/StaffDataSource";
import GenderSelector            from "../common/GenderSelector";
import TopSection                from "../common/layout/TopSection";
import ValidatorMessage          from "../message/ValidatorMessage";

interface Props {
  setPassword: (value: LoginPassword) => void;
}

const StaffRegisterForm: FC<Props> = (props: Props) => {
  const staff: Staff = useStore().getState().staff;
  const repository: StaffRepository = new StaffDataSource(useDispatch());
  return (
    <>
      <TopSection>

      </TopSection>
      <Form>
        <Form.Group>
          <Form.Field required>
            <label>氏名(姓)</label>
            <Input
              defaultValue={ staff.name.lastName.value }
              onChange={ (event, data) => repository.setLastName(new LastName(data.value)) }
            />
            <ValidatorMessage target="last_name"/>
          </Form.Field>
          <Form.Field required>
            <label>氏名(名)</label>
            <Input
              defaultValue={ staff.name.firstName.value }
              onChange={ (event, data) => repository.setFirstName(new FirstName(data.value)) }
            />
            <ValidatorMessage target="first_name"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field required>
            <label>氏名カナ(姓)</label>
            <Input
              defaultValue={ staff.name.lastNameKana.value }
              onChange={ (event, data) => repository.setLastNameKana(new LastNameKana(data.value)) }
            />
            <ValidatorMessage target="last_name_kana"/>
          </Form.Field>
          <Form.Field required>
            <label>氏名カナ(名)</label>
            <Input
              defaultValue={ staff.name.firstNameKana.value }
              onChange={ (event, data) => repository.setFirstNameKana(new FirstNameKana(data.value)) }
            />
            <ValidatorMessage target="first_name_kana"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field required>
            <label>初期パスワード</label>
            <Input
              type="password"
              onChange={ (event, data) => props.setPassword(new LoginPassword(data.value)) }
            />
            <ValidatorMessage target="password"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <GenderSelector
            genderType={ staff.genderType }
            onChange={ genderType => repository.setGenderType(genderType) }
          />
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label>メモ</label>
            <TextArea
              onInput={ (event, data) => repository.setMemo(new StaffMemo(String(data.value))) }
            />
          </Form.Field>
        </Form.Group>
      </Form>
    </>
  );
};

export default StaffRegisterForm;
